export default __webpack_public_path__ + "static/media/escrowSettlement.e0ca78ed.svg";